import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { handleTagManager } from "app/utilities/gtm";

const TrackPageViews: React.FC = (): null => {
  const location = useLocation();

  useEffect(() => {
    const startTime = performance.now();

    requestAnimationFrame(() => {
      const loadTime = performance.now() - startTime;

      window.dataLayer = window.dataLayer || [];
      handleTagManager({
        event: "page_view",
        pagePath: location.pathname,
        pageLoadTime: loadTime.toFixed(2),
      });
    });
  }, [location.pathname]);

  return null;
};

export default TrackPageViews;
